/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */

import React, { useContext, useEffect, useState } from "react";
import { Card, Col, OverlayTrigger, Popover, Row } from "react-bootstrap";
import { Icons } from "../../atoms/Icons";
import Buttons from "../../atoms/Buttons";
import "./mixandmatch.scss";
import {
  FUNDTYPE,
  RA_STEPS_IDENTIFIERS,
  WITHDRAW_CATEGORY,
} from "../../constants/constants";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import Form from "react-bootstrap/Form";
import { useNavigate } from "react-router-dom";
import { ModalOverlay } from "../../atoms/Modal";
import {
  addCommas,
  calculateMonthlyIncome,
  calculateVintage,
  COLOR_PALETTE,
  findFunds,
  hasContextPath,
  openPopup,
  parseInputValue,
} from "../../helpers/helpers";
import { actionCreators } from "../../redux/actions";
import { bindActionCreators } from "redux";
import LoadingSpinner from "../../atoms/Loader";
import { MixAndMatchContext } from "../../context/RAContextProviders/mixAndMatchContext";

const MixandMatch = (props) => {
  const { choose, mixmatchchoice } = useSelector(
    (state) => state.retirementApplication // eslint-disable-line
  );
  const { data: personalData } = useSelector(
    (state) => state.home // eslint-disable-line
  );
  const { payoutRateFetching, payoutRateData, payoutRateError } = useSelector(
    (state) => state.payoutRate,
  );
  const { raCMSFundsFetching, raCMSFundsData, raCMSFundsError } = useSelector(
    (state) => state.raCMSFunds,
  );
  const {
    isMixAndMatchSection,
    flexiValueMixAndMatch,
    miValueMixAndMatch,
    faiValueMixAndMatch,
    annuityValueMixAndMatch,
    legacyValueMixAndMatch,
    safetyValueMixAndMatch,
    resetMixAndMatchValues,
  } = useContext(MixAndMatchContext);
  const navigate = useNavigate(); // eslint-disable-line
  const [miSliderValue, setMiSliderValue] = useState(0);
  const [miInputValue, setMiInputValue] = useState("0%");
  const [futureSliderValue, setFutureSliderValue] = useState(0);
  const [futureInputValue, setFutureInputValue] = useState("0%");
  const [legacySliderValue, setLegacySliderValue] = useState(0);
  const [legacyInputValue, setLegacyInputValue] = useState("0%");
  const [safetySliderValue, setSafetySliderValue] = useState(0);
  const [safetyInputValue, setSafetyInputValue] = useState("0%");
  const [flexiSliderValue, setFlexiSliderValue] = useState(0);
  const [flexiInputValue, setFlexiInputValue] = useState("0%");
  const [annuitySliderValue, setAnnuitySliderValue] = useState(0);
  const [annuityInputValue, setAnnuityInputValue] = useState("0%");
  const [annuityProvider, setAnnuityProvider] = useState("");
  const [flexiIncomePopup, setFlexiIncomePopup] = useState(false);
  const [flexiAccessDuration, setFlexiAccessDuration] = useState("Monthly");
  const [flexiAccessCurrentIncome, setFlexiAccessCurrentIncome] = useState(0);
  const [currentIncome, setCurrentIncome] = useState(0);
  const [frequency, setFrequency] = useState("Monthly");
  const [miRate, setMiRate] = useState(0);
  const [cmsStrategy, setCmsStrategy] = useState();
  const [currentPriceManaged, setCurrentPriceManaged] = useState();
  const [currentPriceFutureAnnuity, setCurrentPriceFutureAnnuity] = useState();
  const [faRate, setFaRate] = useState(0);
  const [annuityScreen, setAnnuityScreen] = useState(false);

  const [flexiAccessChosenAmount, setFlexiAccessChosenAmount] = useState(0);
  const [flexiAccessChosenPeriod, setFlexiAccessChosenPeriod] = useState("");
  const [managedForYouErrorPopup, setManagedForYouErrorPopup] = useState(false);

  const currentDate = new Date();
  let todayDate = dayjs(currentDate).format("DD/MM/YYYY");
  const applyWith =
    mixmatchchoice?.choiceCategory?.mixNmatch?.cashLumpsum?.amount;
  const dispatch = useDispatch();
  const { getRACMSFunds, getPayoutRate, getHomePageContent } =
    bindActionCreators(
      actionCreators,
      dispatch // eslint-disable-line
    );
  const detailsData =
    Object.keys(choose)?.length === 0
      ? JSON.parse(localStorage.getItem("choose"))
      : choose;
  const mixMatchSelectedPercentage =
    mixmatchchoice?.choiceCategory?.mixNmatch?.cashLumpsum?.percentage;
  useEffect(() => {
    if (Object.keys(personalData).length === 0) {
      getHomePageContent(props.investorId);
    }
    if (isMixAndMatchSection) {
      setFlexiSliderValue(flexiValueMixAndMatch);
      setMiSliderValue(miValueMixAndMatch);
      setFutureSliderValue(faiValueMixAndMatch);
      setLegacySliderValue(legacyValueMixAndMatch);
      setSafetySliderValue(safetyValueMixAndMatch);
      setAnnuitySliderValue(annuityValueMixAndMatch);

      // clear mix and match context states
      resetMixAndMatchValues();
    }
  }, []);

  useEffect(() => {
    if (props.investorId) {
      if (Object.keys(raCMSFundsData).length === 0) {
        getRACMSFunds(props.investorId);
      }

      if (
        Object.keys(payoutRateData).length === 0 &&
        personalData?.timeTravel?.birthDate !== undefined
      ) {
        const birthYear = new Date(
          personalData.timeTravel.birthDate,
        ).getFullYear();
        const retirementYear = new Date(
          personalData.timeTravel.retirementDate,
        ).getFullYear();
        getPayoutRate(props.investorId, retirementYear - birthYear);
      }
    }
  }, [personalData, raCMSFundsData, payoutRateData]);

  const managedTotal = Number(
    parseFloat(miInputValue) +
      parseFloat(flexiInputValue) +
      parseFloat(futureInputValue) +
      parseFloat(legacyInputValue) +
      parseFloat(safetyInputValue) +
      parseFloat(annuityInputValue) // eslint-disable-line
  );
  const handleMiSliderChange = (e) => {
    const value = e.target.value;
    setMiSliderValue(value);
    setMiInputValue(`${value}%`);
  };

  const handleMiInputChange = (e) => {
    const result = parseInputValue(e.target.value);
    if (result) {
      setMiSliderValue(result.numericValue);
      setMiInputValue(result.formattedValue);
    }
  };

  const handleFutureSliderChange = (e) => {
    const value = e.target.value;
    setFutureSliderValue(value);
    setFutureInputValue(`${value}%`);
  };

  const handleFutureInputChange = (e) => {
    const result = parseInputValue(e.target.value);
    if (result) {
      setFutureSliderValue(result.numericValue);
      setFutureInputValue(result.formattedValue);
    }
  };

  const handleSafetySliderChange = (e) => {
    const value = e.target.value;
    setSafetySliderValue(value);
    setSafetyInputValue(`${value}%`);
  };

  const handleSafetyInputChange = (e) => {
    const result = parseInputValue(e.target.value);
    if (result) {
      setSafetySliderValue(result.numericValue);
      setSafetyInputValue(result.formattedValue);
    }
  };

  const handleAccountInputChange = (e) => {
    setAnnuityProvider(e.target.value);
  };

  const handleLegacySliderChange = (e) => {
    const value = e.target.value;
    setLegacySliderValue(value);
    setLegacyInputValue(`${value}%`);
  };

  const handleLegacyInputChange = (e) => {
    const result = parseInputValue(e.target.value);
    if (result) {
      setLegacySliderValue(result.numericValue);
      setLegacyInputValue(result.formattedValue);
    }
  };

  const handleFlexiInputChange = (e) => {
    const result = parseInputValue(e.target.value);
    if (result) {
      setFlexiSliderValue(result.numericValue);
      setFlexiInputValue(result.formattedValue);
    }
  };

  const handleFlexiSliderChange = (e) => {
    const value = e.target.value;
    setFlexiSliderValue(value);
    setFlexiInputValue(`${value}%`);
  };

  const handleAnnuitySliderChange = (e) => {
    const value = e.target.value;
    setAnnuitySliderValue(value);
    setAnnuityInputValue(`${value}%`);
  };

  const handleAnnuityInputChange = (e) => {
    const result = parseInputValue(e.target.value);
    if (result) {
      setAnnuitySliderValue(result.numericValue);
      setAnnuityInputValue(result.formattedValue);
    }
  };

  const handleBack = () => {
    props.makeInitialStepper(false, 34, { isMixMatchHowMuchCash: true }, true);
  };

  const handleContinue = () => {
    let currentStep = RA_STEPS_IDENTIFIERS.RA_BEND_STRATEGIES;
    let mixNmatch = {
      investTheRest: {
        faAmount: calculateTotalValue(flexiSliderValue).toFixed(2),
        faChoosenAmount: flexiSliderValue > 0 ? flexiAccessChosenAmount : 0,
        faFequency: flexiSliderValue > 0 ? flexiAccessChosenPeriod : "",
        faPercent: flexiSliderValue > 0 ? parseFloat(flexiSliderValue) : 0,
        miPercent: miSliderValue > 0 ? parseFloat(miSliderValue) : 0,
        faiPercent: futureSliderValue > 0 ? parseFloat(futureSliderValue) : 0,
        miCurrentIncome: calculateMonthlyIncome(
          calculateTotalValue(miSliderValue).toFixed(2),
          miRate,
          currentPriceManaged //eslint-disable-line
        ).toFixed(2),
        faiCurrentIncome: calculateMonthlyIncome(
          calculateTotalValue(futureSliderValue).toFixed(2),
          faRate,
          currentPriceFutureAnnuity //eslint-disable-line
        ).toFixed(2),
        legacyPercent:
          legacySliderValue > 0 ? parseFloat(legacySliderValue) : 0,
        safetynetPercent:
          safetySliderValue > 0 ? parseFloat(safetySliderValue) : 0,
        annuityProvider: annuityScreen ? annuityProvider : "",
        annuityPercent:
          annuitySliderValue > 0 ? parseFloat(annuitySliderValue) : 0,
        annuityAmount:
          annuitySliderValue > 0
            ? calculateTotalValue(annuitySliderValue).toFixed(2)
            : 0,
        miAmount:
          miSliderValue > 0
            ? parseFloat(calculateTotalValue(miSliderValue).toFixed(2))
            : 0,
        faiAmount:
          futureSliderValue > 0
            ? parseFloat(calculateTotalValue(futureSliderValue).toFixed(2))
            : 0,
        legacyAmount:
          legacySliderValue > 0
            ? parseFloat(calculateTotalValue(legacySliderValue).toFixed(2))
            : 0,
        safetynetAmount:
          safetySliderValue > 0
            ? parseFloat(calculateTotalValue(safetySliderValue).toFixed(2))
            : 0,
      },
      retirementId: props.retirementId,
    };

    let payload = {
      currentStep,
      choiceCategory: { mixNmatch },
    };
    props.nextStepIndentifier(RA_STEPS_IDENTIFIERS.RA_BEND_STRATEGIES, payload);
  };

  const calculateTotalValue = (sliderValue) => {
    return (applyWith * sliderValue) / 100;
  };

  const isBetween0And22500 = (v) => Number.isFinite(v) && v > 0 && v < 22500;

  const generateProductOverviewLink = (
    contentType,
    parentStrategyName,
    strategyName,
  ) => {
    let tptProductRoute;
    let finalPath;
    const productOverview = props.cardData?.items?.filter((productOverview) => {
      return (
        productOverview.contentType === contentType &&
        productOverview.name === parentStrategyName
      );
    });
    if (contentType === "productPage") {
      finalPath = productOverview[0]?.route?.path.replace(
        "/guidance/",
        "" //eslint-disable-line
      );
    } else {
      tptProductRoute =
        productOverview[0]?.properties?.optionItem?.items?.filter?.(
          (item) =>
            item?.content?.properties?.retirementOptionListTitle ===
            strategyName //eslint-disable-line
        );
      finalPath =
        tptProductRoute[0]?.content?.properties?.cTA[0]?.route?.path.replace(
          "/guidance/",
          "" //eslint-disable-line
        );
    }
    navigate(`/product-overview/?${finalPath.replace(/\/$/, "")}`, {
      state: {
        doNotCallGetApi: true,
        isMixAndMatch: true,
        flexiSliderValue: parseFloat(flexiSliderValue),
        miSliderValue: parseFloat(miSliderValue),
        futureSliderValue: parseFloat(futureSliderValue),
        annuitySliderValue: parseFloat(annuitySliderValue),
        legacySliderValue: parseFloat(legacySliderValue),
        safetySliderValue: parseFloat(safetySliderValue),
      },
    });
  };

  const handleFlexiAccessContinue = (amount, period) => {
    setFlexiAccessCurrentIncome(amount);
    setFlexiAccessDuration(
      period
        ? period === "Annually"
          ? "Annual"
          : period === "Half yearly"
            ? "HalfYearly"
            : period === "Quarterly"
              ? "Quarterly"
              : "Monthly"
        : "Monthly",
    );
    setFlexiIncomePopup(false);
  };
  useEffect(() => {
    setCurrentIncome(payoutRateData[0]?.currentIncome);
    setFrequency(payoutRateData[0]?.duration);
    setMiRate(payoutRateData[0]?.payOutRates?.managed_income_95_payout_rate);
    setFaRate(payoutRateData[0]?.payOutRates?.future_annuity_75_payout_rate);
    setCurrentPriceManaged(payoutRateData[0]?.managedIncomeBuyPrice);
    setCurrentPriceFutureAnnuity(payoutRateData[0]?.futureAnnuityFundBuyPrice);

    setFlexiAccessCurrentIncome(payoutRateData[0]?.currentIncome);
    setFlexiAccessDuration(payoutRateData[0]?.duration);
  }, [payoutRateData]);
  useEffect(() => {
    const vintage = calculateVintage(
      personalData?.timeTravel?.birthDate?.split("-")[0] // eslint-disable-line
    );

    var colorIndex = COLOR_PALETTE.length;
    setCmsStrategy(
      findFunds(
        raCMSFundsData?.data,
        vintage.age75Year,
        vintage.age95Year // eslint-disable-line
      )?.map(
        (item) => {
          const {
            investmentStyle,
            averageESGRating,
            fundFactsheets,
            fundUse,
            fundObjectiveTruncated,
            composerFundNameTruncated,
            investmentId,
            fundName,
            ...rest
          } = item;
          if (fundName === "Annuity Aware Fund" || investmentId !== null) {
            return {
              strategyId: investmentId,
              strategyName: fundName,
              fundId: composerFundNameTruncated,
              fundType:
                investmentStyle === "Managed for you"
                  ? FUNDTYPE.MANAGED_FOR_ME
                  : investmentStyle,
              ESGRating: averageESGRating,
              managedBy: fundUse,
              shortDesc: fundObjectiveTruncated,
              pDFUrl: fundFactsheets ? fundFactsheets[0].url : null,
              strategyPercentage: 0,
              incomePercentage: 0,
              newCurrentValue: 0,
              newCurrentIncome: 0,
              currentValue: 0,
              currentIncome: 0,
              category:
                fundName.toLowerCase() === "future annuity income fund" ||
                fundName.toLowerCase() === "managed income fund"
                  ? "For Income"
                  : fundName.toLowerCase() === "legacy fund" ||
                      fundName.toLowerCase() === "safety net fund"
                    ? "For Growth"
                    : "",
              color: COLOR_PALETTE[--colorIndex],
              ...rest,
            };
          }
        } // eslint-disable-line
      ) // eslint-disable-line
    );
  }, [personalData, raCMSFundsData]);
  props.setFaiId(
    cmsStrategy?.find(
      (fund) => fund?.strategyName === "Future Annuity Income Fund" //eslint-disable-line
    )?.strategyId ?? 0 // eslint-disable-line
  );

  props.setMiId(
    cmsStrategy?.find(
      (fund) => fund?.strategyName === "Managed Income Fund" //eslint-disable-line
    )?.strategyId ?? 0 // eslint-disable-line
  );
  props.setLeId(
    cmsStrategy?.find(
      (fund) => fund?.strategyName === "Legacy Fund" //eslint-disable-line
    )?.strategyId ?? 0 // eslint-disable-line
  );
  props.setSnId(
    cmsStrategy?.find(
      (fund) => fund?.strategyName === "Safety Net Fund" //eslint-disable-line
    )?.strategyId ?? 0 // eslint-disable-line
  );

  if (payoutRateFetching || raCMSFundsFetching) {
    return <LoadingSpinner width={55} />;
  }

  return (
    <>
      {!annuityScreen ? (
        <>
          <Card className="application-step">
            <Card.Body className="mix-and-match">
              <Row className="mix-match-container">
                <Col md={9}>
                  <Row>
                    <Col md={12} className="mb-fourty">
                      <p className="guidance _title">Mix and match</p>
                    </Col>
                  </Row>
                  <Row className="invest_content">
                    <Col md={10} className="invest_content-left">
                      <p>
                        You've chosen how much of your pension pot you'd like to
                        take as a cash lump sum. So now we need to know what
                        you'd like to do with the rest of your pot.
                      </p>{" "}
                      <p> You can mix and match any of the options below.</p>
                      <p>
                        {Number(applyWith) >= 22500 ? (
                          <>
                            <span className="fw-bold">Managed for you:</span>
                            <br />
                            If you choose a <i>Managed for you</i> option,
                            you’ll need to allocate a{" "}
                            <span className="fw-bold">minimum of £22,500</span>{" "}
                            to either of these choices.
                          </>
                        ) : (
                          ""
                        )}
                      </p>
                    </Col>
                  </Row>
                  <div className="managed-income">
                    <div className="managed-income-heading">
                      <span className="manage-heading-text">
                        {"Managed for you"}
                      </span>
                    </div>
                    {Number(applyWith) < 22500 ? (
                      <Row className="MixMatchCradView">
                        <Col xl={6} lg={6} md={6}>
                          <div className="locked-flexi-card">
                            <div className="flexi-card-front">
                              <div>
                                <Icons
                                  iconname="locked"
                                  variant="icon-twenty-four-px"
                                />
                              </div>
                              <div className="manage-flexi-text">
                                Managed income
                              </div>
                              <div className="manage-flexi--access">
                                {parseFloat(
                                  detailsData?.monetaryChosenAmount //eslint-disable-line
                                ) >= 30000 && parseFloat(applyWith) < 22500
                                  ? "To access this option, at least £22,500 must be moved into drawdown. You can access this option by reducing the amount of cash you take."
                                  : "If you have at least £30k in pension savings in this retirement application, you can access the options."}
                              </div>
                            </div>
                          </div>
                        </Col>
                        <Col xl={6} lg={6} md={6}>
                          <div className="locked-flexi-card">
                            <div className="flexi-card-front">
                              <div>
                                <Icons
                                  iconname="locked"
                                  variant="icon-twenty-four-px"
                                />
                              </div>
                              <div className="manage-flexi-text">
                                Future annuity income
                              </div>
                              <div className="manage-flexi--access">
                                {parseFloat(
                                  detailsData?.monetaryChosenAmount //eslint-disable-line
                                ) >= 30000 && parseFloat(applyWith) < 22500
                                  ? "To access this option, at least £22,500 must be moved into drawdown. You can access this option by reducing the amount of cash you take."
                                  : "If you have at least £30k in pension savings in this retirement application, you can access the options."}
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    ) : (
                      <Row className="MixMatchCradView">
                        <Col xs={6}>
                          <div className="retirement-card">
                            <div className="sub-header-div">
                              <span
                                className="circle ps-2 mt-1"
                                style={{
                                  backgroundColor: COLOR_PALETTE[0],
                                }}
                              ></span>
                              <span className="sub-header">Managed income</span>
                              <span className="fund-category">
                                {cmsStrategy?.find(
                                  (fund) =>
                                    fund?.strategyName ===
                                    "Managed Income Fund", //eslint-disable-line
                                )?.category == WITHDRAW_CATEGORY.FOR_INCOME
                                  ? "INCOME"
                                  : cmsStrategy?.find(
                                        (fund) =>
                                          fund?.strategyName ===
                                          "Managed Income Fund", //eslint-disable-line
                                      )?.category ==
                                      WITHDRAW_CATEGORY.SELF_MANAGED
                                    ? "SELF MANAGED"
                                    : "GROWTH"}
                              </span>
                            </div>
                            <hr className="upper-line-managed" />
                            <div className="parent-text">
                              <div className="current-value-text">
                                Current value:
                              </div>
                              <div className="current-value">
                                {"£" +
                                  addCommas(
                                    calculateTotalValue(miSliderValue).toFixed(
                                      2 //eslint-disable-line
                                    ) //eslint-disable-line
                                  )}{" "}
                              </div>
                            </div>
                            <div className="parent-text">
                              <div className="current-value-text">
                                Current income:
                              </div>
                              <div className="current-value">
                                {"£" +
                                  addCommas(
                                    calculateMonthlyIncome(
                                      calculateTotalValue(
                                        miSliderValue //eslint-disable-line
                                      ).toFixed(2),
                                      miRate,
                                      currentPriceManaged //eslint-disable-line
                                    ).toFixed(2) //eslint-disable-line
                                  )}{" "}
                                p/m
                              </div>
                            </div>
                            <hr className="lower-line" />
                            <p className="fund-text">
                              {
                                cmsStrategy?.find(
                                  (fund) =>
                                    fund?.strategyName === "Managed Income Fund" //eslint-disable-line
                                )?.shortDesc
                              }
                            </p>
                            <Row className="fund-text slider-card-section">
                              <Col lg={7} md={7} className="card-slide">
                                <Form.Range
                                  value={miSliderValue}
                                  name="safetySlider"
                                  max={100}
                                  onChange={handleMiSliderChange}
                                  className="custom-slider"
                                />
                              </Col>
                              <Col lg={4} md={4} className="card-input">
                                <input
                                  type="text"
                                  className="input-text"
                                  value={`${miSliderValue}%`}
                                  onChange={handleMiInputChange}
                                  onFocus={(e) => {
                                    if (e.target.value === "0%") {
                                      e.target.value = "%";
                                    }
                                  }}
                                  onBlur={(e) => {
                                    if (e.target.value === "%") {
                                      e.target.value = "0%";
                                      handleMiInputChange({
                                        target: { value: "0%" },
                                      }); // Ensure state is updated
                                    }
                                  }}
                                  min="0"
                                  max="100"
                                />
                              </Col>
                            </Row>
                            <Row className="fund-text prod-guide">
                              <Col lg={6} md={6}>
                                <div className="button-align">
                                  <div className="view-fund-button">
                                    <Buttons
                                      name="View full fund fact sheet"
                                      className="tertiary"
                                      handleClick={() =>
                                        openPopup(
                                          cmsStrategy?.find(
                                            (fund) =>
                                              fund?.strategyName ===
                                              "Managed Income Fund" //eslint-disable-line
                                          )?.pDFUrl //eslint-disable-line
                                        )
                                      }
                                    ></Buttons>
                                  </div>
                                  <div>
                                    <Buttons
                                      name="See product guide"
                                      className="secondary"
                                      handleClick={() => {
                                        generateProductOverviewLink(
                                          "questionPage",
                                          "TPT drawdown",
                                          "Managed income" //eslint-disable-line
                                        );
                                      }}
                                    ></Buttons>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </Col>
                        <Col xs={6}>
                          <div className="retirement-card">
                            <div className="sub-header-div">
                              <span
                                className="circle ps-2 mt-1"
                                style={{
                                  backgroundColor: COLOR_PALETTE[2],
                                }}
                              ></span>
                              <span className="sub-header">
                                Future annuity income
                              </span>
                              <span className="fund-category">
                                {cmsStrategy?.find(
                                  (fund) =>
                                    fund?.strategyName ===
                                    "Future Annuity Income Fund", //eslint-disable-line
                                )?.category == WITHDRAW_CATEGORY.FOR_INCOME
                                  ? "INCOME"
                                  : cmsStrategy?.find(
                                        (fund) =>
                                          fund?.strategyName ===
                                          "Future Annuity Income Fund", //eslint-disable-line
                                      )?.category ==
                                      WITHDRAW_CATEGORY.SELF_MANAGED
                                    ? "SELF MANAGED"
                                    : "GROWTH"}
                              </span>
                            </div>
                            <hr className="upper-line-managed" />
                            <div className="parent-text">
                              <div className="current-value-text">
                                Current value:
                              </div>
                              <div className="current-value">
                                {"£" +
                                  addCommas(
                                    calculateTotalValue(
                                      futureSliderValue //eslint-disable-line
                                    ).toFixed(2) //eslint-disable-line
                                  )}{" "}
                              </div>
                            </div>
                            <div className="parent-text">
                              <div className="current-value-text">
                                Current income:
                              </div>
                              <div className="current-value">
                                {"£" +
                                  addCommas(
                                    calculateMonthlyIncome(
                                      calculateTotalValue(
                                        futureSliderValue //eslint-disable-line
                                      ).toFixed(2),
                                      faRate,
                                      currentPriceFutureAnnuity //eslint-disable-line
                                    ).toFixed(2) //eslint-disable-line
                                  )}{" "}
                                p/m
                              </div>
                            </div>
                            <hr className="lower-line" />
                            <p className="fund-text">
                              {
                                cmsStrategy?.find(
                                  (fund) =>
                                    fund?.strategyName ===
                                    "Future Annuity Income Fund" //eslint-disable-line
                                )?.shortDesc
                              }
                            </p>
                            <Row className="fund-text slider-card-section">
                              <Col lg={7} md={7} className="card-slide">
                                <Form.Range
                                  value={futureSliderValue}
                                  name="safetySlider"
                                  max={100}
                                  onChange={handleFutureSliderChange}
                                  className="custom-slider"
                                />
                              </Col>
                              <Col lg={4} md={4} className="card-input">
                                <input
                                  type="text"
                                  className="input-text"
                                  value={`${futureSliderValue}%`}
                                  onChange={handleFutureInputChange}
                                  onFocus={(e) => {
                                    if (e.target.value === "0%") {
                                      e.target.value = "%";
                                    }
                                  }}
                                  onBlur={(e) => {
                                    if (e.target.value === "%") {
                                      e.target.value = "0%";
                                      handleFutureInputChange({
                                        target: { value: "0%" },
                                      }); // Ensure state is updated
                                    }
                                  }}
                                  min="0"
                                  max="100"
                                />
                              </Col>
                            </Row>
                            <Row className="fund-text prod-guide">
                              <Col lg={6} md={6}>
                                <div className="button-align">
                                  <div className="view-fund-button">
                                    <Buttons
                                      name="View full fund fact sheet"
                                      className="tertiary"
                                      handleClick={() =>
                                        openPopup(
                                          cmsStrategy?.find(
                                            (fund) =>
                                              fund?.strategyName ===
                                              "Future Annuity Income Fund" //eslint-disable-line
                                          )?.pDFUrl //eslint-disable-line
                                        )
                                      }
                                    ></Buttons>
                                  </div>
                                  <div>
                                    <Buttons
                                      name="See product guide"
                                      className="secondary"
                                      handleClick={() => {
                                        generateProductOverviewLink(
                                          "questionPage",
                                          "TPT drawdown",
                                          "Future annuity" //eslint-disable-line
                                        );
                                      }}
                                    ></Buttons>
                                  </div>
                                </div>
                              </Col>
                            </Row>
                          </div>
                        </Col>
                      </Row>
                    )}
                    <Row>
                      <Col lg={6}>
                        <div className="retirement-card">
                          <div className="sub-header-div">
                            <span
                              className="circle ps-2 mt-1"
                              style={{
                                backgroundColor: COLOR_PALETTE[3],
                              }}
                            ></span>
                            <span className="sub-header">Legacy</span>
                            <span className="fund-category">
                              {cmsStrategy?.find(
                                (fund) => fund?.strategyName === "Legacy Fund", //eslint-disable-line
                              )?.category == WITHDRAW_CATEGORY.FOR_INCOME
                                ? "INCOME"
                                : cmsStrategy?.find(
                                      (fund) =>
                                        fund?.strategyName === "Legacy Fund", //eslint-disable-line
                                    )?.category ===
                                    WITHDRAW_CATEGORY.SELF_MANAGED
                                  ? "SELF MANAGED"
                                  : "GROWTH"}
                            </span>
                            <hr className="upper-line" />
                          </div>{" "}
                          <div className="parent-text">
                            <div className="current-value-text">
                              Current value:
                            </div>
                            <div className="current-value">
                              {"£" +
                                addCommas(
                                  calculateTotalValue(
                                    legacySliderValue //eslint-disable-line
                                  ).toFixed(2) //eslint-disable-line
                                )}{" "}
                            </div>
                          </div>
                          <hr className="lower-line" />
                          <p className="fund-text">
                            {
                              cmsStrategy?.find(
                                (fund) =>
                                  fund?.strategyName === "Safety Net Fund" //eslint-disable-line
                              )?.shortDesc
                            }
                          </p>
                          <Row className="fund-text slider-card-section">
                            <Col lg={7} md={7} className="card-slide">
                              <Form.Range
                                value={legacySliderValue}
                                name="safetySlider"
                                max={100}
                                onChange={handleLegacySliderChange}
                                className="custom-slider"
                              />
                            </Col>
                            <Col lg={4} md={4} className="card-input">
                              <input
                                type="text"
                                className="input-text"
                                value={`${legacySliderValue}%`}
                                onChange={handleLegacyInputChange}
                                onFocus={(e) => {
                                  if (e.target.value === "0%") {
                                    e.target.value = "%";
                                  }
                                }}
                                onBlur={(e) => {
                                  if (e.target.value === "%") {
                                    e.target.value = "0%";
                                    handleLegacyInputChange({
                                      target: { value: "0%" },
                                    }); // Ensure state is updated
                                  }
                                }}
                                min="0"
                                max="100"
                              />
                            </Col>
                          </Row>
                          <Row className="fund-text prod-guide">
                            <Col lg={6} md={6}>
                              <div className="button-align">
                                <div className="view-fund-button">
                                  <Buttons
                                    name="View full fund fact sheet"
                                    className="tertiary"
                                    handleClick={() =>
                                      openPopup(
                                        cmsStrategy?.find(
                                          (fund) =>
                                            fund?.strategyName === "Legacy Fund" //eslint-disable-line
                                        )?.pDFUrl //eslint-disable-line
                                      )
                                    }
                                  ></Buttons>
                                </div>
                                <div>
                                  <Buttons
                                    name="See product guide"
                                    className="secondary"
                                    handleClick={() => {
                                      generateProductOverviewLink(
                                        "productPage",
                                        "Tax-free cash as a lump sum, legacy",
                                        "Legacy for investing your drawdown" //eslint-disable-line
                                      );
                                    }}
                                  ></Buttons>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <div className="retirement-card">
                          <div className="sub-header-div">
                            <span
                              className="circle ps-2 mt-1"
                              style={{
                                backgroundColor: COLOR_PALETTE[9],
                              }}
                            ></span>
                            <span className="sub-header">Safety net</span>
                            <span className="fund-category">
                              {cmsStrategy?.find(
                                (fund) =>
                                  fund?.strategyName === "Safety Net Fund", //eslint-disable-line
                              )?.category == WITHDRAW_CATEGORY.FOR_INCOME
                                ? "INCOME"
                                : cmsStrategy?.find(
                                      (fund) =>
                                        fund?.strategyName ===
                                        "Safety Net Fund", //eslint-disable-line
                                    )?.category ==
                                    WITHDRAW_CATEGORY.SELF_MANAGED
                                  ? "SELF MANAGED"
                                  : "GROWTH"}
                            </span>
                            <hr className="upper-line" />
                          </div>{" "}
                          <div className="parent-text">
                            <div className="current-value-text">
                              Current value:
                            </div>
                            <div className="current-value">
                              {"£" +
                                addCommas(
                                  calculateTotalValue(
                                    safetySliderValue //eslint-disable-line
                                  ).toFixed(2) //eslint-disable-line
                                )}{" "}
                            </div>
                          </div>
                          <hr className="lower-line" />
                          <p className="fund-text">
                            {
                              cmsStrategy?.find(
                                (fund) =>
                                  fund?.strategyName === "Safety Net Fund" //eslint-disable-line
                              )?.shortDesc
                            }
                          </p>
                          <Row className="fund-text slider-card-section">
                            <Col lg={7} md={7} className="card-slide">
                              <Form.Range
                                value={safetySliderValue}
                                name="safetySlider"
                                max={100}
                                onChange={handleSafetySliderChange}
                                className="custom-slider"
                              />
                            </Col>
                            <Col lg={4} md={4} className="card-input">
                              <input
                                type="text"
                                className="input-text"
                                value={`${safetySliderValue}%`}
                                onChange={handleSafetyInputChange}
                                onFocus={(e) => {
                                  if (e.target.value === "0%") {
                                    e.target.value = "%";
                                  }
                                }}
                                onBlur={(e) => {
                                  if (e.target.value === "%") {
                                    e.target.value = "0%";
                                    handleSafetyInputChange({
                                      target: { value: "0%" },
                                    }); // Ensure state is updated
                                  }
                                }}
                                min="0"
                                max="100"
                              />
                            </Col>
                          </Row>
                          <Row className="fund-text prod-guide">
                            <Col lg={6} md={6}>
                              <div className="button-align">
                                <div className="view-fund-button">
                                  <Buttons
                                    name="View full fund fact sheet"
                                    className="tertiary"
                                    handleClick={() =>
                                      openPopup(
                                        cmsStrategy?.find(
                                          (fund) =>
                                            fund?.strategyName ===
                                            "Safety Net Fund" //eslint-disable-line
                                        )?.pDFUrl //eslint-disable-line
                                      )
                                    }
                                  ></Buttons>
                                </div>
                                <div>
                                  <Buttons
                                    name="See product guide"
                                    className="secondary"
                                    handleClick={() => {
                                      generateProductOverviewLink(
                                        "productPage",
                                        "Tax-free cash as a lump sum, safety net",
                                        "Safety net for investing your drawdown" //eslint-disable-line
                                      );
                                    }}
                                  ></Buttons>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className="managed-income">
                    <div className="managed-income-heading">
                      <span className="manage-heading-text">
                        {"Self-managed"}
                      </span>
                    </div>
                    <Row>
                      <Col lg={6}>
                        <div className="retirement-card">
                          <div className="sub-header-div">
                            <span
                              className="circle ps-2 mt-1"
                              style={{
                                backgroundColor: COLOR_PALETTE[1],
                              }}
                            ></span>
                            <span className="sub-header">Flexi-access</span>
                          </div>{" "}
                          <hr className="upper-line-flexi" />
                          <div className="parent-text">
                            <div className="current-value-text">
                              Current value:
                            </div>
                            <div className="current-value">
                              {"£" +
                                addCommas(
                                  calculateTotalValue(flexiSliderValue).toFixed(
                                    2 //eslint-disable-line
                                  ) //eslint-disable-line
                                )}{" "}
                            </div>
                          </div>
                          <div className="parent-text">
                            <div className="current-value-text">
                              Current income:
                            </div>
                            <div className="current-value">
                              {"£" +
                                addCommas(
                                  currentIncome //eslint-disable-line
                                )}{" "}
                              {frequency === "Monthly"
                                ? "p/m"
                                : frequency === "Quarterly"
                                  ? "p/q"
                                  : frequency === "HalfYearly"
                                    ? "p/6m"
                                    : frequency === "Annual"
                                      ? "p/y"
                                      : ""}
                            </div>
                          </div>
                          <hr className="lower-line" />
                          <p className="fund-text-flexi">
                            A fully flexible option where you decide the funds
                            you’d like to invest, when you take out money and
                            how much.
                          </p>
                          <Row className="fund-text slider-card-section">
                            <Col lg={7} md={7} className="card-slide">
                              <Form.Range
                                value={flexiSliderValue}
                                name="flexiSlider"
                                max={100}
                                onChange={handleFlexiSliderChange}
                                className="change-investment-slider"
                              />
                            </Col>
                            <Col lg={4} md={4} className="card-input">
                              <input
                                type="text"
                                className="input-text"
                                value={`${flexiSliderValue}%`}
                                onChange={handleFlexiInputChange}
                                onFocus={(e) => {
                                  if (e.target.value === "0%") {
                                    e.target.value = "%";
                                  }
                                }}
                                onBlur={(e) => {
                                  if (e.target.value === "%") {
                                    e.target.value = "0%";
                                    handleFlexiInputChange({
                                      target: { value: "0%" },
                                    }); // Ensure state is updated
                                  }
                                }}
                                min="0"
                                max="100"
                              />
                            </Col>
                          </Row>
                          <Row className="fund-text prod-guide">
                            <Col>
                              <div className="button-align-flexi">
                                <div>
                                  <Buttons
                                    name="See product guide"
                                    className="secondary"
                                    handleClick={() => {
                                      generateProductOverviewLink(
                                        "questionPage",
                                        "Take regular income",
                                        "Self-managed regular income" //eslint-disable-line
                                      );
                                    }}
                                  ></Buttons>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div className="managed-income">
                    <div className="managed-income-heading">
                      <span className="manage-heading-text">{"Annuity"}</span>
                    </div>
                    <Row>
                      <Col lg={6}>
                        <div className="retirement-card">
                          <div className="sub-header-div">
                            <span
                              className="circle ps-2 mt-1"
                              style={{
                                backgroundColor: COLOR_PALETTE[6],
                              }}
                            ></span>
                            <span className="sub-header">Annuity</span>
                          </div>{" "}
                          <hr className="upper-line-flexi" />
                          <div className="parent-text">
                            <div className="current-value-text">
                              Current value:
                            </div>
                            <div className="current-value">
                              {"£" +
                                addCommas(
                                  calculateTotalValue(
                                    annuitySliderValue //eslint-disable-line
                                  ).toFixed(
                                    2 //eslint-disable-line
                                  ) //eslint-disable-line
                                )}{" "}
                            </div>
                          </div>
                          <hr className="lower-line" />
                          <p className="fund-text">
                            {
                              cmsStrategy?.find(
                                (fund) =>
                                  fund?.strategyName === "Annuity Aware Fund" //eslint-disable-line
                              )?.shortDesc
                            }
                          </p>
                          <Row className="fund-text slider-card-section">
                            <Col lg={7} md={7} className="card-slide">
                              <Form.Range
                                value={annuitySliderValue}
                                name="safetySlider"
                                max={100}
                                onChange={handleAnnuitySliderChange}
                                className="custom-slider"
                              />
                            </Col>
                            <Col lg={4} md={4} className="card-input">
                              <input
                                type="text"
                                className="input-text"
                                value={`${annuitySliderValue}%`}
                                onChange={handleAnnuityInputChange}
                                onFocus={(e) => {
                                  if (e.target.value === "0%") {
                                    e.target.value = "%";
                                  }
                                }}
                                onBlur={(e) => {
                                  if (e.target.value === "%") {
                                    e.target.value = "0%";
                                    handleAnnuityInputChange({
                                      target: { value: "0%" },
                                    }); // Ensure state is updated
                                  }
                                }}
                                min="0"
                                max="100"
                              />
                            </Col>
                          </Row>
                          <Row className="fund-text prod-guide">
                            <Col lg={6} md={6}>
                              <div className="button-align">
                                <div className="view-fund-button">
                                  <Buttons
                                    name="View full fund fact sheet"
                                    className="tertiary"
                                    handleClick={() =>
                                      openPopup(
                                        cmsStrategy?.find(
                                          (fund) =>
                                            fund?.strategyName === "Annuity Aware Fund" //eslint-disable-line
                                        )?.pDFUrl //eslint-disable-line
                                      )
                                    }
                                  ></Buttons>
                                </div>
                                <div>
                                  <Buttons
                                    name="See product guide"
                                    className="secondary"
                                    handleClick={() => {
                                      generateProductOverviewLink(
                                        "productPage",
                                        "Annuity",
                                        "Annuity" //eslint-disable-line
                                      );
                                    }}
                                  ></Buttons>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Col>
                <Col md={3} className="right-text">
                  <div className="right-row">
                    <p>Applying with:</p>
                    <p className="bold-text">
                      £{addCommas(detailsData?.monetaryChosenAmount)}
                    </p>
                  </div>
                  <div className="right-row">
                    <p>Moving to TPT drawdown:</p>
                    <p className="bold-text">£{addCommas(applyWith)}</p>
                  </div>
                  <div className="right-row">
                    <p>Taking as cash:</p>
                    <p className="bold-text">
                      £
                      {addCommas(
                        (mixMatchSelectedPercentage > 25
                          ? (25 * detailsData?.monetaryChosenAmount) / 100
                          : (mixMatchSelectedPercentage *
                              detailsData?.monetaryChosenAmount) /
                            100
                        ).toFixed(2) //eslint-disable-line
                      )}
                    </p>
                  </div>
                  <div className="right-row">
                    <p>Annuity:</p>
                    <p className="bold-text">
                      {"£" +
                        addCommas(
                          calculateTotalValue(annuitySliderValue).toFixed(
                            2 //eslint-disable-line
                          ) //eslint-disable-line
                        )}{" "}
                    </p>
                  </div>
                  <p className="bold-text tpt-text mb-1">TPT drawdown</p>
                  <div className="right-row">
                    <p>Managed income:</p>
                    <p className="bold-text">
                      {"£" +
                        addCommas(
                          calculateTotalValue(miSliderValue).toFixed(2) //eslint-disable-line
                        )}
                    </p>
                  </div>
                  <div className="right-row">
                    <p>Future annuity income:</p>
                    <p className="bold-text">
                      {"£" +
                        addCommas(
                          calculateTotalValue(futureSliderValue).toFixed(
                            2 //eslint-disable-line
                          ) //eslint-disable-line
                        )}{" "}
                    </p>
                  </div>
                  <div className="right-row">
                    <p>Legacy:</p>
                    <p className="bold-text">
                      {"£" +
                        addCommas(
                          calculateTotalValue(legacySliderValue).toFixed(2) //eslint-disable-line
                        )}{" "}
                    </p>
                  </div>
                  <div className="right-row">
                    <p>Safety net:</p>
                    <p className="bold-text">
                      {"£" +
                        addCommas(
                          calculateTotalValue(safetySliderValue).toFixed(2) //eslint-disable-line
                        )}{" "}
                    </p>
                  </div>
                  <div className="right-row">
                    <p>Flexi access:</p>
                    <p className="bold-text">
                      {"£" +
                        addCommas(
                          calculateTotalValue(flexiSliderValue).toFixed(
                            2 //eslint-disable-line
                          ) //eslint-disable-line
                        )}{" "}
                    </p>
                  </div>
                  <div className="m-42 d-flex align-items-center">
                    <div className="value-correct-date ms-1">
                      {" "}
                      Values correct as of {todayDate}
                    </div>

                    <OverlayTrigger
                      placement="right"
                      overlay={
                        <Popover
                          id="popover-contained"
                          className="tooltip-popover-section"
                        >
                          <Popover.Body className="tooltip-popover-body">
                            <p>
                              {" "}
                              All the values are estimates, based on the most
                              accurate information available. They include all
                              the contributions paid by you and your employer.
                            </p>
                            <p>
                              The value of your pension savings is based on
                              current financial conditions and is not
                              guaranteed. The amounts you receive may be higher
                              or lower than the amounts shown above. Payment of
                              your pension will be subject to TPT’s Trust Deed
                              and Rules, and regulatory requirements.
                            </p>{" "}
                          </Popover.Body>
                        </Popover>
                      }
                      flip={true}
                    >
                      <span className="textarea-tooltip ms-1">
                        {" "}
                        <Icons iconname="tool-tip" variant="icon-twelve-px" />
                      </span>
                    </OverlayTrigger>
                  </div>
                </Col>
              </Row>
              <div className="footer-btn-container">
                <Buttons
                  handleClick={handleBack}
                  className="secondary back-btn"
                  name="Back"
                />
                <div>
                  <span className="funds-selected">
                    Allocated: {Number(managedTotal)}%
                  </span>
                  <Buttons
                    handleClick={() => {
                      if (Number(flexiSliderValue) > 0) {
                        if (
                          Number(applyWith) >= 22500 &&
                          (isBetween0And22500(
                            Number(calculateTotalValue(miSliderValue)) //eslint-disable-line
                          ) ||
                            isBetween0And22500(
                              Number(calculateTotalValue(futureSliderValue)) //eslint-disable-line
                            ))
                        ) {
                          setManagedForYouErrorPopup(true);
                        } else setFlexiIncomePopup(true);
                      } else if (
                        Number(annuitySliderValue) > 0 &&
                        Number(flexiSliderValue) < 1
                      ) {
                        if (
                          Number(applyWith) >= 22500 &&
                          (isBetween0And22500(
                            Number(calculateTotalValue(miSliderValue)) //eslint-disable-line
                          ) ||
                            isBetween0And22500(
                              Number(calculateTotalValue(futureSliderValue)) //eslint-disable-line
                            ))
                        ) {
                          setManagedForYouErrorPopup(true);
                        } else setAnnuityScreen(true);
                      } else {
                        if (
                          Number(applyWith) >= 22500 &&
                          (isBetween0And22500(
                            Number(calculateTotalValue(miSliderValue)) //eslint-disable-line
                          ) ||
                            isBetween0And22500(
                              Number(calculateTotalValue(futureSliderValue)) //eslint-disable-line
                            ))
                        ) {
                          setManagedForYouErrorPopup(true);
                        } else handleContinue();
                      }
                    }}
                    className="primary"
                    name="Continue"
                    disabled={managedTotal === 100 ? false : true}
                  />
                </div>
              </div>
              <ModalOverlay
                popup="choosingFlexiAccessRetirement"
                show={flexiIncomePopup}
                onHide={(e) => {
                  if (e !== undefined) {
                    e.preventDefault();
                  }
                  setFlexiIncomePopup(false);
                }}
                modaltitle="Choosing flexi-access"
                flexiAcessCurrentIncome={flexiAccessCurrentIncome}
                flexiAccessDuration={flexiAccessDuration}
                flexiAccessTotalValue={parseFloat(
                  calculateTotalValue(flexiSliderValue).toFixed(2) //eslint-disable-line
                )}
                handleFlexiAccessContinue={(amount, period) => {
                  handleFlexiAccessContinue(amount, period);
                  if (Number(annuitySliderValue > 0)) {
                    setFlexiAccessChosenAmount(
                      Number(String(amount ?? "").replace("£", "").trim()) //eslint-disable-line
                    );
                    setFlexiAccessChosenPeriod(
                      period
                        ? period === "Annually"
                          ? "Annual"
                          : period === "Half yearly"
                            ? "HalfYearly"
                            : period === "Quarterly"
                              ? "Quarterly"
                              : "Monthly"
                        : "Monthly" //eslint-disable-line
                    );
                    setAnnuityScreen(true);
                  } else {
                    let currentStep = RA_STEPS_IDENTIFIERS.RA_BEND_STRATEGIES;
                    let mixNmatch = {
                      investTheRest: {
                        faAmount:
                          calculateTotalValue(flexiSliderValue).toFixed(2),
                        faChoosenAmount: Number(
                          String(amount ?? "")
                            .replace("£", "")
                            .trim() //eslint-disable-line
                        ),
                        faFequency: period
                          ? period === "Annually"
                            ? "Annual"
                            : period === "Half yearly"
                              ? "HalfYearly"
                              : period === "Quarterly"
                                ? "Quarterly"
                                : "Monthly"
                          : "Monthly",
                        faPercent:
                          flexiSliderValue > 0 ? parseInt(flexiSliderValue) : 0,
                        miPercent:
                          miSliderValue > 0 ? parseInt(miSliderValue) : 0,
                        miCurrentIncome:
                          calculateMonthlyIncome(
                            calculateTotalValue(miSliderValue).toFixed(2),
                            miRate,
                            currentPriceManaged //eslint-disable-line
                          ).toFixed(2) ?? "0",
                        faiCurrentIncome:
                          calculateMonthlyIncome(
                            calculateTotalValue(futureSliderValue).toFixed(2),
                            faRate,
                            currentPriceFutureAnnuity //eslint-disable-line
                          ).toFixed(2) ?? "0",
                        faiPercent:
                          futureSliderValue > 0
                            ? parseInt(futureSliderValue)
                            : 0,
                        legacyPercent:
                          legacySliderValue > 0
                            ? parseInt(legacySliderValue)
                            : 0,
                        safetynetPercent:
                          safetySliderValue > 0
                            ? parseInt(safetySliderValue)
                            : 0,
                        annuityProvider: annuityProvider,
                        annuityPercent:
                          annuitySliderValue > 0
                            ? parseInt(annuitySliderValue)
                            : 0,
                        annuityAmount:
                          annuitySliderValue > 0
                            ? calculateTotalValue(annuitySliderValue).toFixed(2)
                            : 0,
                        miAmount:
                          miSliderValue > 0
                            ? parseFloat(
                                calculateTotalValue(miSliderValue).toFixed(2) //eslint-disable-line
                              ) //eslint-disable-line
                            : 0,
                        faiAmount:
                          futureSliderValue > 0
                            ? parseFloat(
                                calculateTotalValue(futureSliderValue).toFixed(
                                  2 //eslint-disable-line
                                ) //eslint-disable-line
                              ) //eslint-disable-line
                            : 0,
                        legacyAmount:
                          legacySliderValue > 0
                            ? parseFloat(
                                calculateTotalValue(legacySliderValue).toFixed(
                                  2 //eslint-disable-line
                                ) //eslint-disable-line
                              ) //eslint-disable-line
                            : 0,
                        safetynetAmount:
                          safetySliderValue > 0
                            ? parseFloat(
                                calculateTotalValue(safetySliderValue).toFixed(
                                  2 //eslint-disable-line
                                ) //eslint-disable-line
                              ) //eslint-disable-line
                            : 0,
                      },
                      retirementId: props.retirementId,
                    };

                    let payload = {
                      currentStep,
                      choiceCategory: { mixNmatch },
                    };
                    props.nextStepIndentifier(
                      RA_STEPS_IDENTIFIERS.RA_BEND_STRATEGIES,
                      payload // eslint-disable-line
                    );
                  }
                }}
                isCancel={false}
              />
              <ModalOverlay
                popup="LeavingTPTSuccessModel"
                show={managedForYouErrorPopup}
                onHide={() => setManagedForYouErrorPopup(false)}
                description={
                  <>
                    To proceed, choose a value of £22,500 or higher for{" "}
                    <i>Managed for you</i> options.
                  </>
                }
                btnContinuedName="Got it!"
                handleClick={() => {
                  setManagedForYouErrorPopup(false);
                }}
              />
            </Card.Body>
          </Card>
        </>
      ) : (
        <>
          <Card className="application-step">
            <Card.Body className="confirm-your-choices">
              <div className="annuity-section">
                <div>
                  <h2 className="heading">Annuity details</h2>
                  <p>
                    You can buy an annuity from an insurance company or
                    specialist provider. TPT doesn&apos;t provide annuities but
                    you can use our quick quote tool for an estimate (in the
                    Plan your future tool). Visit{" "}
                    <a
                      href="https://www.moneyhelper.org.uk/en/pensions-and-retirement/taking-your-pension"
                      className="moneyhelper-link text-decoration-underline"
                    >
                      <span className="fw-bold">MoneyHelper</span>
                    </a>{" "}
                    for a more detailed quote or seek guidance or independent
                    advice.
                  </p>
                  <p>
                    There are many types of annuity to choose from, and the
                    amount you get from each can vary, especially at older ages
                    or if you qualify for an &apos;enhanced&apos; annuity if you
                    have health conditions.
                  </p>
                  <p>
                    Annuity quotes are typically only valid for a fixed period.
                    You may require an updated quote or to shop around again
                    closer to your payment date, especially if you are awaiting
                    a final contribution to be paid into your pension.
                  </p>
                  <p>Please advise the name of your annuity provider</p>
                </div>
                <div className="input-section">
                  <p>Annuity provider </p>
                  <input
                    type="text"
                    className="input-text large-input"
                    value={annuityProvider}
                    onChange={handleAccountInputChange}
                    maxLength={40}
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(
                        /[^a-zA-Z \-_]/g,
                        "" //eslint-disable-line
                      );
                    }}
                    placeholder="Annuity provider name"
                  />
                </div>
                <div className="annuity-provider">
                  <span className="fw-bold">Important: </span> Your tax-free
                  cash will be paid at the same time as your annuity provider.
                  Kindly ask your provider or financial adviser to share full
                  payment instructions with us, so that we can process your
                  application. You can upload the details at{" "}
                  <span
                    className="getintouch-link fw-bold"
                    onClick={() => navigate("/get-in-touch/")}
                  >
                    get in touch
                  </span>
                  .
                </div>
              </div>
            </Card.Body>
            <div className="footer-btn-container">
              <Buttons
                handleClick={() => {
                  setAnnuityScreen(false);
                }}
                className="secondary back-btn"
                name="Back"
              />

              <Buttons
                handleClick={() => {
                  if (annuityProvider != "") {
                    handleContinue();
                  }
                }}
                className="primary"
                name="Continue"
                disabled={annuityProvider != "" ? false : true}
              />
            </div>
          </Card>
        </>
      )}
    </>
  );
};
export default MixandMatch;
